import { render, staticRenderFns } from "./PIATest.vue?vue&type=template&id=876ec162&scoped=true&"
import script from "./PIATest.vue?vue&type=script&lang=js&"
export * from "./PIATest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876ec162",
  null
  
)

export default component.exports